import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mr-3" }
const _hoisted_2 = {
  key: 0,
  class: "material-symbols-outlined mr-2"
}

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderElement',
  props: {
    sortKey: {},
    sortType: {},
    elementKey: {},
    title: {},
    titleWidth: { default: '100%' },
    labelStyle: { default: '' },
    searchable: { type: Boolean, default: false },
    sortable: { type: Boolean, default: false },
    isAllSelected: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const searchStatusIcon = computed(() => () => {
  if (props.isAllSelected) {
    return 'filter_list'
  }
  return 'filter_alt'
})

const isDisplaySortIcon = computed(() => (key: string) => {
  if (props.sortKey && props.sortKey == key) {
    return 'sort'
  }
  return ''
})

const sortStatus = computed(() => () => {
  if (props.sortType == 'ASC') {
    return -1
  }
  return 1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex justify-content-end",
    style: _normalizeStyle(props.labelStyle)
  }, [
    _createElementVNode("div", {
      class: "d-flex justify-content-between align-center",
      style: _normalizeStyle(`width: ${props.titleWidth}`)
    }, [
      _createTextVNode(_toDisplayString(props.title) + " ", 1),
      _createElementVNode("div", _hoisted_1, [
        (props.searchable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(searchStatusIcon.value(props.elementKey)), 1))
          : _createCommentVNode("", true),
        (props.sortable)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "material-symbols-outlined",
              style: _normalizeStyle(`transform: scaleY(${sortStatus.value()})`)
            }, _toDisplayString(isDisplaySortIcon.value(props.elementKey)), 5))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 4))
}
}

})